import { Injector } from "@angular/core";
import { MeddraTerm } from "../../../Data/MeddraData/MeddraTerm";
import { FieldDefinition } from "../../../../../sections/meddra/message/fieldDefinition";
import { TreeNodeMeddraLevel } from "./TreeNodeMeddraLevel";
import { TreeNodeSOCItem } from "./TreeNodeSOCItem";
import { MeddraNode } from "../MeddraNode";
import { EntityEnum } from "../../EntityEnum";
import { BaseNode } from "../../BaseNode";
import { SectionService } from "../../../../service/section-service/section-service";


export class TreeNodeSOCLevel extends TreeNodeMeddraLevel {


    constructor(injector: Injector, items: any[]|undefined, parent: BaseNode|undefined) {
        super(injector, items, EntityEnum.soc, parent);
    }

    override addChild(item: any): MeddraNode | null {
        const node = new TreeNodeSOCItem(this.ioc!,
            new MeddraTerm(new FieldDefinition(this.ioc!).socFields, item), this)
        return this.addItem(item, node);
    }

    override addChildren(items: any[]): void {
        let newChild: BaseNode|undefined = undefined;
        items.forEach(item => {
            let lastAddedChildren = this.addItem(item, new TreeNodeSOCItem(this.ioc!,
                new MeddraTerm(new FieldDefinition(this.ioc!).socFields, item), this));
                if (newChild == undefined) {
                    newChild = lastAddedChildren;
                }
        })
        if (newChild) {
            this.ioc!.get(SectionService).selectMeddraNode(newChild);
        }
    }

    override removeChildren(items: any[]): void {
        items.forEach(item => {
            this.removeItem(item, new TreeNodeSOCItem(this.ioc!,
                new MeddraTerm(new FieldDefinition(this.ioc!).socFields, item), this));
        });
    }

    override getCriteriaFields(): string[] {
        return ['code', 'name', 'abbreviation'];
    }

    override getPlaceHolderTemplate(): string{
        return "Search SOC Terms for the selected MedDRA version available in the XEVMPD";
    }
}
